import { defineQuery } from "next-sanity";

export const ALL_PRODUCT_CATEGORIES = defineQuery(`*[_type=="productCategory" && defined(slug.current)] | order(position asc){
  name,
  title,
  position,
  classRef,
  "slug": slug.current,
  translationLabel,
}`)

export const ALL_PRODUCTS_LIST = defineQuery(`*[_type=="product" && defined(slug.current) && language == $locale] {
  code,
  internalCode,
  name,
  "slug": slug.current,
  category[]->{title, "slug": slug.current},
  "coverImage": coverImage.asset->url,
  disableFamilyGrouping,
  _updatedAt,
}`)

export const ALL_PRODUCTS_LIST_PAGED = defineQuery(`*[_type=="product" && defined(slug.current) && language == $locale] [$startIndex..$endIndex]{
  code,
  internalCode,
  name,
  "slug": slug.current,
  category[]->{title, "slug": slug.current},
  "coverImage": coverImage.asset->url,
  disableFamilyGrouping,
  _updatedAt,
}`)

export const ALL_PRODUCTS_IN_CATEGORY = defineQuery(`*[_type=="product" && defined(slug.current) && $categorySlug in category[]->slug.current && language == $locale] {
  code,
  internalCode,
  name,
  "slug": slug.current,
  category[]->{title, "slug": slug.current},
  "coverImage": coverImage.asset->url,
  disableFamilyGrouping,
  _updatedAt,
}`)

export const ALL_PRODUCTS_IN_CATEGORY_PAGED = defineQuery(`*[_type=="product" && defined(slug.current) && $categorySlug in category[]->slug.current && language == $locale] [$startIndex...$endIndex]{
  code,
  internalCode,
  name,
  "slug": slug.current,
  category[]->{title, "slug": slug.current},
  "coverImage": coverImage.asset->url,
  disableFamilyGrouping,
  _updatedAt,
}`)

export const PRODUCT_SEARCH = defineQuery(`
*[
    _type == "product" &&
    (name match $searchQuery || internalCode match $searchQuery) &&
    language == $locale
]
| order(_score desc)
{
    code,
    internalCode,
    name,
    "slug": slug.current,
    "category": category[]->{
      title,
      "slug": slug.current
    },
    "coverImage": coverImage.asset->url,
    disableFamilyGrouping,
    _updatedAt,
}[$startIndex...$endIndex]`);

export const PRODUCT_DETAILS = defineQuery(`*[_type=="product" && defined(slug.current) && slug.current == $slug]{
  code,
  internalCode,
  name,
  "slug": slug.current,
  "category": category[]->{title, "slug": slug.current},
  "coverImage": coverImage.asset->url,
  "image": image[]->asset->url,
  "attributes": attributes[]->{label, "image": image.asset->url, "slug": slug.current},
  description,
  application,
  safety,
  youtubeUrl,
  "downloads": downloads[]{
    asset->{
      _id,
      url,
      originalFilename,
      size
    }
  },
  "securityNoticesDownloads": securityNoticesDownloads[]{
    asset->{
      _id,
      url,
      originalFilename,
      size
    }
  },
  "applicationProducts": applicationProducts[]->{
    code,
    internalCode,
    name,
    "slug": slug.current,
    "category": category[]->{title, "slug": slug.current},
    "coverImage": coverImage.asset->url,
  },
  "similarProducts": similarProducts[]->{
    code,
    internalCode,
    name,
    "slug": slug.current,
    "category": category[]->{title, "slug": slug.current},
    "coverImage": coverImage.asset->url,
  },
  disableFamilyGrouping,
  _updatedAt,
}`);

export const ALL_BLOG_CATEGORIES = defineQuery(`*[_type=="blogCategory" && defined(slug.current)] | order(position asc){
  name,
  title,
  position,
  "slug": slug.current,
}`)

export const ALL_BLOG_POSTS = defineQuery(`*[_type=="blogArticle" && defined(slug.current) && language == $locale] | order(publishedDate desc) {
  title,
  "slug": slug.current,
  intro,
  category[]->{title, "slug": slug.current},
  language,
  "imageUrl": image.asset->url,
  _updatedAt,
}`);

export const ALL_BLOG_POSTS_PAGED = defineQuery(`*[_type=="blogArticle" && defined(slug.current) && language == $locale] | order(publishedDate desc) [$startIndex...$endIndex]{
  title,
  "slug": slug.current,
  intro,
  category[]->{title, "slug": slug.current},
  language,
  "imageUrl": image.asset->url,
  _updatedAt,
}`);

export const ALL_BLOG_POSTS_IN_CATEGORY = defineQuery(`*[_type=="blogArticle" && defined(slug.current) && $categorySlug in category[]->slug.current && language == $locale] | order(publishedDate desc) {
  title,
  "slug": slug.current,
  intro,
  category[]->{title, "slug": slug.current},
  publishDate,
  language,
  "imageUrl": image.asset->url,
  _updatedAt,
}`);

export const ALL_BLOG_POSTS_IN_CATEGORY_PAGED = defineQuery(`*[_type=="blogArticle" && defined(slug.current) && $categorySlug in category[]->slug.current && language == $locale] | order(publishedDate desc) [$startIndex...$endIndex]{
  title,
  "slug": slug.current,
  intro,
  category[]->{title, "slug": slug.current},
  publishDate,
  language,
  "imageUrl": image.asset->url,
  _updatedAt,
}`);

/*export const BLOG_POSTS_SLICE_IN_CATEGORY = defineQuery(`*[_type=="blogArticle" && defined(slug.current) && $categorySlug in category[]->slug.current && language == $locale] | order(publishedDate desc) [$startIndex...$endIndex]{
  title,
  "slug": slug.current,
  intro,
  category[]->{title, "slug": slug.current},
  publishDate,
  language,
  "imageUrl": image.asset->url,
}`);*/

export const GET_BLOG_POST = defineQuery(`*[_type=="blogArticle" && defined(slug.current) && slug.current == $slug]{
  title,
  "slug": slug.current,
  intro,
  category[]->{title, "slug": slug.current},
  publishDate,
  "author": author->{
    name,
    "image": image.asset->url,
    role,
  },
  language,
  "imageUrl": image.asset->url,
  body[]{
    ...,
    _type == "image" => {
      ...,
      "imageUrl": image.asset->url
    },
    _type == "embeddedProduct" => {
      ...,
      product[]->{
        name,
        code,
        internalCode,
        "coverImage": coverImage.asset->url,
        "slug": slug.current,
        category[]->{title, "slug": slug.current},
      }
    }
  },
  _updatedAt,
}`);

export const GET_PARTNERS_OVERVIEW = defineQuery(`*[_type=="partnerAndLocation"] | order(position asc) {
  _id,
  name,
  countryCode,
  sellsAll,
  invento,
  "imageUrl": image.asset->url,
  addressLine1,
  addressLine2,
  zip,
  town,
  country,
  phone,
  email,
  website,
  geolocation,
}`);

export const GET_FULL_PARTNER_PROFILE = defineQuery(`*[_type=="partnerAndLocation" && _id==$id]{
  _id,
  name,
  countryCode,
  sellsAll,
  invento,
  "imageUrl": image.asset->url,
  addressLine1,
  addressLine2,
  zip,
  town,
  country,
  phone,
  email,
  website,
  products[]->{
    code,
    internalCode,
    name,
    "slug": slug.current,
    "category": category[]->{
      title,
      "slug": slug.current
    },
    "coverImage": coverImage.asset->url,
  },
  geolocation,
}`);

export const GET_TEAM = defineQuery(`*[_type=="teamMember"] | order(position asc) {
  _id,
  name,
  position,
  "imageUrl": image.asset->url,
  role,
  intro,
  email,
  mainPhone,
  directPhone,
}`);

export const GET_HISTORY = defineQuery(`*[_type=="history"] | order(position asc) {
  _id,
  name,
  position,
  when,
  what,
  description,
}`);

export const GET_JOB_POSITIONS = defineQuery(`*[_type=="jobPosition"] | order(position asc) {
  _id,
  jobTitle,
  position,
  language,
  description,
  "contact": contact->{
    name,
    email,
    role,
  },
  contactEmail,
}`);

export const GET_SERVICES = defineQuery(`*[_type=="service"] | order(position asc) {
  _id,
  title,
  position,
  "imageUrl": image.asset->url,
  name,
  description,
  price,
}`);

export const GET_PRODUCT_DOC = defineQuery(`*[_type == "sanity.fileAsset" && _id==$id]{
  _id,
  originalFilename,
  label,
  title,
  description,
  assetId,
  path,
  source,
  url,
}`)
